import React, { useEffect, useState } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import "./baseStyles.css";
import "./MyLockedPage.css";
const apiUrl = process.env.REACT_APP_API_URL;


const MyDailyLockedPage = () => {
  const navigate = useNavigate();
  const [cognitoUserId, setCognitoUserId] = useState(null);
  const [userCampaigns, setUserCampaigns] = useState([]);
  const [personalItem, setPersonalItem] = useState(null);
  const [commercialItem, setCommercialItem] = useState(null);
  const [error, setError] = useState("");
  const [marketingMessage, setMarketingMessage] = useState("✨ Here's your daily inspiration. Stay focused, stay grateful. ✨");
  const [selectedUnified, setSelectedUnified] = useState("");
  const [advancing, setAdvancing] = useState(false);


  // Decode token and fetch campaigns
  useEffect(() => {
    const token = localStorage.getItem("idToken");
    if (!token) return navigate("/login");

    try {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now()) throw new Error("Expired token");
      setCognitoUserId(decoded.sub);
      fetchUserCampaigns(decoded.sub);
    } catch (err) {
      localStorage.removeItem("idToken");
      navigate("/login");
    }
  }, []);

  const fetchUserCampaigns = async (userid) => {
    try {
      const res = await axios.get(
        `${apiUrl}`,
        {
          params: { operation: "fetch_all", userid },
          headers: { Authorization: `Bearer ${localStorage.getItem("idToken")}` },
        }
      );
      setUserCampaigns(res.data || []);
    } catch (err) {
      setError("Error loading campaigns.");
    }
  };

const fetchNextItem = async (campaignName, setItem) => {
  try {
    const res = await axios.post(
      `${apiUrl}`,
      {
        operation: "read_next_item",
        userid: cognitoUserId,
        campaignName,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("idToken")}` },
      }
    );

    const firstItem = Array.isArray(res.data) ? res.data[0] : res.data;
    setItem(firstItem || null);
  } catch (err) {
    console.error("Fetch failed:", err);
    setItem({ campaignItemsText: "Failed to load item." });
  }
};



  // Refresh items every 5 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      if (selectedUnified) {
        const campaign = userCampaigns.find((c) => c.campaignListName === selectedUnified);
        if (campaign?.campaignListCampaignType === "PersonalReminders") {
          fetchNextItem(selectedUnified, setPersonalItem);
        } else {
          fetchNextItem(selectedUnified, setCommercialItem);
        }
      }
    }, 300000); // 5 minutes
    return () => clearInterval(interval);
  }, [selectedUnified, userCampaigns]);



const renderDropdown = (label, campaigns, selected, setSelected, onSelect) => (
  <div className="dropdown-container">
    <div className="campaign-card" style={{ padding: "16px", textAlign: "left" }}>
      <label htmlFor="campaign-select" style={{ fontSize: "0.7rem", fontWeight: "bold", display: "block", marginBottom: "4px" }}>
        {label}
      </label>
      <select
        id="campaign-select"
        className="compact-select"
        value={selected}
        onChange={(e) => {
          const val = e.target.value;
          setSelected(val);
          if (val) onSelect(val);
        }}
      >
        <option value="">-- Select a Campaign --</option>
        {campaigns.map((c) => (
          <option key={c.campaignName} value={c.campaignName}>
            {c.campaignName.replace(`${cognitoUserId}_`, "")}
          </option>
        ))}
      </select>
    </div>
  </div>
);




useEffect(() => {
  // Load shared marketing message from global campaign
  fetchMarketingMessage();
}, []);

const fetchMarketingMessage = async () => {
  try {
    const res = await axios.post(`${apiUrl}`, {
      operation: "read_next_item",  // if you want to advance
      userid: "myDailyReminders",
      campaignName: "myDailyReminders - Marketing 1"
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("idToken")}` // or skip if public
      }
    });

    setMarketingMessage(res.data?.[0]?.campaignItemsText || "✨ Welcome to myDailyReminders ✨");
  } catch (err) {
    console.error("Failed to load marketing message", err);
  }
};




const handleReadNext = async () => {
  if (!selectedUnified || advancing) return;
  setAdvancing(true);
  //clearStatusMessages?.();

  try {
    const idToken = localStorage.getItem("idToken");
    const { sub: userId } = jwtDecode(idToken);

    const res = await axios.post(
      `${apiUrl}`,
      { operation: "read_next_item", userid: userId, campaignName: selectedUnified },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );

    const item = Array.isArray(res.data) ? res.data[0] : res.data;
    if (!item || item.campaignItemsId == null) return;

    // Decide which pane to update based on the selected campaign’s type
    const meta = userCampaigns.find(c => c.campaignListName === selectedUnified);
    if (meta?.campaignListCampaignType === "PersonalReminders") {
      setPersonalItem(item);
      setCommercialItem(null);
    } else {
      setCommercialItem(item);
      setPersonalItem(null);
    }
  } catch (err) {
    console.error("Error fetching next item:", err);
    setError?.("Failed to fetch the next item.");
  } finally {
    setAdvancing(false);
  }
};






  return (


<div className="container">
  <h2 className="header-dropped desktop-only">Today's Motivation</h2>
  <h2 className="header-dropped-mobile mobile-only">Today's Motivation</h2>

  {/* DESKTOP (table layout) */}
  <div className="desktop-only">
    <table style={{ width: "100%", maxWidth: "960px", margin: "0 auto", marginTop: "24px" }}>
      <tbody>
        <tr>
          <td style={{ verticalAlign: "top", width: "220px", paddingRight: "20px" }}>
            {renderDropdown(
              "Choose Your Reminder Campaign",
              userCampaigns.filter(
                (c) =>
                  c.campaignListCampaignType === "PersonalReminders" ||
                  c.campaignListCampaignType === "CommercialReminders"
              ),
              selectedUnified,
              setSelectedUnified,
              (campaignName) => {
                const campaign = userCampaigns.find((c) => c.campaignListName === campaignName);
                if (campaign?.campaignListCampaignType === "PersonalReminders") {
                  fetchNextItem(campaignName, setPersonalItem);
                  setCommercialItem(null);
                } else {
                  fetchNextItem(campaignName, setCommercialItem);
                  setPersonalItem(null);
                }
              }
            )}
          </td>


          <td style={{ verticalAlign: "top" }}>
            {(personalItem || commercialItem) && (
              <div className="campaign-description" style={{

                  fontSize: "1.6rem",
                  padding: "40px",
                  backgroundColor: "#fdfdfd",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                  textAlign: "center",
                  lineHeight: "1.8",
                  fontWeight: 400,
                  color: "#222",



                }}>
                {(personalItem?.campaignItemsText || commercialItem?.campaignItemsText) || "No content available."}
                <div style={{ fontSize: "0.85rem", textAlign: "right", marginTop: "20px", color: "#555" }}>
                  — {personalItem?.campaignItemsAuthor || commercialItem?.campaignItemsAuthor}
                </div>
              </div>
            )}

            {/* Read Next button */}
            <div style={{ textAlign: "center", marginTop: 16 }}>
              <button
                className="save-button"
                onClick={handleReadNext}
                disabled={!selectedUnified || advancing}
                title={!selectedUnified ? "Select a campaign first" : ""}
              >
                {advancing ? "Loading…" : "Read Next"}
              </button>
            </div>
          </td>



        </tr>
      </tbody>
    </table>
  </div>

  {/* MOBILE (stacked layout) */}
  <div className="mobile-only" style={{ maxWidth: 640, margin: "0 auto", marginTop: 16 }}>
    <div style={{ marginBottom: 12 }}>
      {renderDropdown(
        "Choose Your Reminder Campaign",
        userCampaigns.filter(
          (c) =>
            c.campaignListCampaignType === "PersonalReminders" ||
            c.campaignListCampaignType === "CommercialReminders"
        ),
        selectedUnified,
        setSelectedUnified,
        (campaignName) => {
          const campaign = userCampaigns.find((c) => c.campaignListName === campaignName);
          if (campaign?.campaignListCampaignType === "PersonalReminders") {
            fetchNextItem(campaignName, setPersonalItem);
            setCommercialItem(null);
          } else {
            fetchNextItem(campaignName, setCommercialItem);
            setPersonalItem(null);
          }
        }
      )}
    </div>



    {(personalItem || commercialItem) && (
      <div className="campaign-description" style={{
                      fontSize: "1.6rem",
                      padding: "40px",
                      backgroundColor: "#fdfdfd",
                      borderRadius: "10px",
                      border: "1px solid #ddd",
                      textAlign: "center",
                      lineHeight: "1.8",
                      fontWeight: 400,
                      color: "#222",
        }}>
        {(personalItem?.campaignItemsText || commercialItem?.campaignItemsText) || "No content available."}
        <div style={{ fontSize: "0.85rem", textAlign: "right", marginTop: 16, color: "#555" }}>
          — {personalItem?.campaignItemsAuthor || commercialItem?.campaignItemsAuthor}
        </div>
      </div>
    )}

    {/* Read Next button */}
    <div style={{ textAlign: "center", marginTop: 16 }}>
      <button
        className="save-button"
        onClick={handleReadNext}
        disabled={!selectedUnified || advancing}
        title={!selectedUnified ? "Select a campaign first" : ""}
      >
        {advancing ? "Loading…" : "Read Next"}
      </button>
    </div>





  </div>








<div className="footer-note">
  <p className="footer-message">{marketingMessage}</p>
  <em className="footer-credit">from myDailyReminders</em>
</div>



      {error && <p className="error-message">{error}</p>}
    </div>

  );
};

export default MyDailyLockedPage;
